import { Examination_Type } from "@generated/graphql";
import TestingLink from "components/TestingLink";
import useIsCreate from "hooks/useIsCreate";
import { UseFormGetValues, UseFormReturn } from "react-hook-form";
import ReminderSwitch from "../../components/ReminderSwitch";
import TestingSourceControl from "../../components/TestingSourceControl";
import { CompetencyMapOptionList, ScenarioOption } from "../../types";
import { GroupAndOpenInfoInputs } from "../types";

interface GroupAndOpenRightProps {
  form: UseFormReturn<GroupAndOpenInfoInputs>;
  examinationType: Examination_Type | undefined;
  competencyMaps: CompetencyMapOptionList;
  competencyMapsLoading: boolean;
  scenarios: ScenarioOption[] | undefined;
  scenariosLoading: boolean;
  isEditing: boolean;
}

const GroupAndOpenRight = ({
  form,
  examinationType,
  competencyMaps,
  competencyMapsLoading,
  scenarios,
  scenariosLoading,
  isEditing,
}: GroupAndOpenRightProps) => {
  const isCreate = useIsCreate();
  const getValues = form.getValues as unknown as UseFormGetValues<GroupAndOpenInfoInputs>;

  const showTestingLink = examinationType === Examination_Type.Open || examinationType === Examination_Type.Public;

  return (
    <>
      <TestingSourceControl
        competencyMaps={competencyMaps}
        isEditing={isCreate}
        competencyMapsLoading={competencyMapsLoading}
        scenarios={scenarios}
        scenariosLoading={scenariosLoading}
        type='examination'
      />
      {showTestingLink && <TestingLink link={getValues("link")} />}
      {examinationType === Examination_Type.Group && <ReminderSwitch isEditing={isEditing} />}
      {/* пока оставил, вдруг понадобится */}
      {/* {examinationType === Examination_Type.Group && (
        <Stack spacing={0.5}>
          <FieldLabel label='Загрузить кандидатов' />
          <FileUploadButton
            name='candidatesFile'
            label='Загрузить кандидатов'
            accept='.xlsx'
          />
        </Stack>
      )} */}
    </>
  );
};

export default GroupAndOpenRight;
